import GSAP from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'


export default class Timeline {
	constructor()
	{
		this.aboutTimeline = document.querySelector('.block-timeline');
		this.photoGrid = document.querySelector('.photo-grid__grid');

		if(this.aboutTimeline && this.photoGrid) {
			let lineContainer = document.querySelector('.block-timeline__line-container');
			let linePosition = this.photoGrid.querySelectorAll('span');

			function positionLine() {
				if(window.innerWidth < 768) {
					lineContainer.style.left = '30px';
				} else if (window.innerWidth >= 768 && window.innerWidth < 1024) {
					lineContainer.style.left = linePosition[4].offsetLeft + 'px';
				} else if (window.innerWidth >= 1024) {
					lineContainer.style.left = linePosition[7].offsetLeft + 'px';
				}
			}
			positionLine();
			window.onresize = function(event) {
				positionLine();
			}
		}

		if(this.aboutTimeline) {
			let line          		= document.querySelector('.block-timeline__line');
			let lineWrapper         = document.querySelector('.block-timeline');
			let lastLineItem        = document.querySelector('.block-timeline .item:last-of-type');
			//let scrollingHeight 	= lineWrapper.offsetHeight - lastLineItem.offsetHeight;

			GSAP.set(line, {transformOrigin: "center top", xPercent: -50, x: 0})

			GSAP.fromTo(line, {
				scaleY: 0,
			}, {
				scaleY: 1,
				ease: "none",
				scrollTrigger: {
					trigger: lineWrapper,
					start: "top 400px",
					end: "bottom 200px",
					scrub: true,
					invalidateOnRefresh: true,
				}
			});
		}
	}
}
